import(/* webpackMode: "eager" */ "/vercel/path0/app/ressurser/bmi-kalkulator/page.tsx");
